import BaseMobileWorkbenchSetting from '@framework/workbench/setting/base/base-mobile-setting';
import { MOBILE_CONTEXT_MENU } from '@framework/workbench/schema/context-menu-schema/toc/mobile';
import { OcrController } from '@framework/workbench/ui/ocr-mobile/ocr-controller';
import {
    DownloadAttachmentController,
} from '@framework/workbench/ui/download-attachment/download-attachment-controller';
import { SwitchShowTypeController } from '@framework/workbench/ui/switch-show-type/switch-show-type-controller';
import { ViewAttachmentController } from '@framework/workbench/ui/view-attachment/view-attachment-controller';
import { DeleteAttachmentController } from '@framework/workbench/ui/delete-attachment/delete-attachment-controller';

export default class TocMobileWorkbenchSetting extends BaseMobileWorkbenchSetting {
    protected getContextMenuSchema(): string[] {
        return MOBILE_CONTEXT_MENU;
    }

    protected getController(): Function[] {
        return [
            ...super.getController(),
            OcrController,
            DownloadAttachmentController,
            SwitchShowTypeController,
            ViewAttachmentController,
            DeleteAttachmentController,
        ];
    }
}
